import { format, parse } from 'date-fns';

export function convertTimeTo12HourFormat(time: string): string {
	const date = parse(time, 'HH:mm', new Date());

	return format(date, 'h:mm aaaa');
}
